__turbopack_context__.v({
  "box": "index-module-scss-module__eaum0G__box",
  "icon": "index-module-scss-module__eaum0G__icon",
  "item": "index-module-scss-module__eaum0G__item",
  "modal": "index-module-scss-module__eaum0G__modal",
  "title": "index-module-scss-module__eaum0G__title",
});
